import { useNavigate, useLocation } from 'react-router-dom';

export default function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const usuario = JSON.parse(localStorage.getItem('usuario') || '{}');

  const menus = [
    { label: 'Dashboard', path: '/dashboard', todos: true },
    { label: 'Clientes', path: '/clientes', todos: true },
    { divider: true, label: 'PAUTAS', todos: true },
    { label: 'Consultar', path: '/pauta/consultar', todos: true, cor: '#546e7a' },
    { label: 'Em Prospecção', path: '/pauta/prospeccao', todos: true, cor: '#7b1fa2' },
    { label: 'Em Andamento', path: '/pauta/andamento', todos: true, cor: '#1976d2' },
    { label: 'Aguardando Registro', path: '/pauta/registro', todos: true, cor: '#f57c00' },
    { label: 'Aguardando Financeiro', path: '/pauta/financeiro', todos: true, cor: '#0097a7' },
    { label: 'Finalizado', path: '/pauta/finalizado', todos: true, cor: '#388e3c' },
    { divider: true, label: 'FINANCEIRO', todos: true },
    { label: 'Despesas (Interna)', path: '/despesas', todos: true, cor: '#e53935' },
    { label: 'Reembolsos (Cliente)', path: '/reembolsos', todos: true, cor: '#e53935' },
    { divider: true, label: 'CONFIGURAÇÕES', todos: false },
    { label: 'Tabela de Produtos', path: '/precos', todos: true },
    { label: 'Parâmetros', path: '/parametros', todos: true },
    { label: 'Usuários', path: '/usuarios', todos: false },
  ];

  return (
    <div style={styles.sidebar}>
      <div style={styles.logo}>
        <img src="/logo.png" alt="Vera Soluções" style={{ width: '100px' }} />
        <p style={styles.perfil}>{usuario.nome} · {usuario.perfil}</p>
      </div>
      <nav style={styles.nav}>
        {menus.map((menu, i) => {
          if (!menu.todos && usuario.perfil !== 'master') return null;
          if (menu.divider) return <p key={i} style={styles.divider}>{menu.label}</p>;
          const ativo = location.pathname === menu.path;
          return (
            <button
              key={menu.path}
              style={{ ...styles.navItem, ...(ativo ? styles.navAtivo : {}) }}
              onClick={() => navigate(menu.path)}
            >
              {menu.cor && <span style={{ ...styles.bolinha, backgroundColor: menu.cor }} />}
              {menu.label}
            </button>
          );
        })}
      </nav>
      <button style={styles.logout} onClick={() => { localStorage.clear(); navigate('/login'); }}>
        Sair
      </button>
    </div>
  );
}

const styles = {
  sidebar: {
    width: '220px', minWidth: '220px', backgroundColor: '#1a1a2e',
    display: 'flex', flexDirection: 'column', height: '100vh',
    flexShrink: 0, overflow: 'hidden',
  },
  logo: {
    padding: '8px 1rem', borderBottom: '1px solid rgba(255,255,255,0.1)',
    display: 'flex', flexDirection: 'column', alignItems: 'center',
    textAlign: 'center', flexShrink: 0,
  },
  perfil: { color: '#666', fontSize: '10px', margin: '2px 0 0', textTransform: 'capitalize' },
  nav: { display: 'flex', flexDirection: 'column', gap: '0px', flex: 1, padding: '0.25rem 1rem', minHeight: 0, overflowY: 'auto' },
  navItem: { backgroundColor: 'transparent', color: '#ccc', border: 'none', padding: '6px 12px', borderRadius: '6px', textAlign: 'left', fontSize: '12px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px' },
  navAtivo: { backgroundColor: 'rgba(255,255,255,0.1)', color: '#fff' },
  bolinha: { width: '8px', height: '8px', borderRadius: '50%', flexShrink: 0 },
  divider: { color: '#444', fontSize: '9px', fontWeight: '600', letterSpacing: '1px', margin: '8px 0 2px 12px' },
  logout: {
    flexShrink: 0, backgroundColor: 'transparent', color: '#888',
    border: 'none', borderTop: '1px solid rgba(255,255,255,0.1)',
    padding: '10px', fontSize: '13px', cursor: 'pointer', width: '100%', textAlign: 'center',
  },
};